import {
  POSTING_LOADING,
  CLEAR_LOADING,
  //VIP_POST_QUESTION,
  VIP_GET_QUESTION_BY_CHECKID,
  VIP_GET_QUESTION_BY_ID,
  VIP_QUESTION_INIT_SETUP,
  //VIP_GET_USER_BY_TOKEN,
  VIP_GET_REPLIES,
  VIP_CLOSE_QUESTION,
  VIP_GET_QUESTION_LIST,
} from '../actions/types';

const initialState = {
  question: {},
  question_list: [],
  token: null,
  user: null,
  loading: false,
  is_in_game: false,
  unread_count: 0,
  game_id: null,
  game_name: null,
  vip_ranking: null,
  member_link: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    /*case VIP_POST_QUESTION:
      return {
        ...state,
        question: action.payload,
        loading: false,
      };*/
    case VIP_GET_QUESTION_BY_CHECKID:
      let { check_id, email, mobile, question_id, token } = action.payload;
      return {
        ...state,
        token,
        user: { check_id, email, mobile, question_id },
        loading: false,
      };
    case VIP_QUESTION_INIT_SETUP:
      return {
        ...state,
        token: action.payload.token,
        is_in_game: action.payload.is_in_game,
        unread_count: action.payload.unread_count,
        game_id: action.payload.game_id,
        game_name: action.payload.game_name,
        loading: false,
        isVipreportWhitelisted: action.payload.isVipreportWhitelisted,
        vip_ranking: action.payload.vip_ranking,
        member_link: action.payload.member_link,
      };

    case VIP_GET_QUESTION_BY_ID:
      return {
        ...state,
        question: action.payload.msg,
        loading: false,
        is_in_game: action.payload.is_in_game,
      };
    case VIP_GET_QUESTION_LIST:
      return {
        ...state,
        question_list: action.payload,
        loading: false,
      };

    case VIP_GET_REPLIES:
      return {
        ...state,
        question: {
          ...state.question,
          replies: action.payload.replies,
          pic_plus: action.payload.pic_plus,
        },
        loading: false,
      };
    case VIP_CLOSE_QUESTION:
      return {
        ...state,
        question: { ...state.question, status: '4' },
        loading: false,
      };

    /*case VIP_GET_USER_BY_TOKEN:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };*/

    case POSTING_LOADING:
      return {
        ...state,
        loading: true,
      };
    case CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
